<div class="flex flex-col h-screen bg-white overflow-hidden">
    <!-- Header -->
    <header class="flex-none p-6 z-20 bg-white relative">
        <a routerLink="/login" class="inline-block">
            <img src="assets/FINTRAX_LOGO_POS.svg" alt="Fintrax" class="h-10" />
        </a>
    </header>

    <!-- Main Content -->
    <main class="flex-grow flex items-center justify-center p-6 bg-slate-50/50 overflow-y-auto">
        <div class="w-full max-w-md bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col my-auto">
            
            <h1 class="text-2xl font-bold text-slate-800 mb-6 text-center" i18n="@@resetPassword.forgotPassword">Wachtwoord vergeten</h1>

            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="flex flex-col w-full gap-5">
                
                <div class="flex flex-col gap-2">
                    <label for="inputEmail" class="text-sm font-medium text-slate-700" i18n="@@email">E-mailadres</label>
                    <input 
                        id="inputEmail" 
                        type="email" 
                        formControlName="email" 
                        class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                        required 
                        autocomplete="email" 
                    />
                </div>

                @if (success) {
                    <div class="p-4 bg-green-50 text-green-700 rounded-lg text-sm text-center" i18n="@@resetPassword.newPasswordMessage">
                        Nieuw wachtwoord werd aangevraagd. Check je email!
                    </div>
                }

                <button 
                    type="submit" 
                    class="button-primary w-full py-3 mt-2 rounded-lg font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    [disabled]="!resetForm.valid || busy || success"
                >
                    @if (!busy) {
                        <span i18n="@@resetPassword.newPassword">Nieuw wachtwoord aanvragen</span>
                    } @else {
                        <fa-icon [icon]="loadingIcon" [animation]="'spin'"></fa-icon>
                    }
                </button>

                <div class="mt-4 flex justify-center">
                    <a routerLink="/login" class="font-bold text-blue-600 hover:text-blue-700 hover:underline text-sm" i18n="@@public.backToLogin">Terug naar loginpagina</a>
                </div>

            </form>
        </div>
    </main>
</div>
